import { Injectable } from '@angular/core'
import { NgNotificationServiceInterface } from '../../models/notification.model'
import {
  FileModalCode,
  FileNotificationCode,
  parseFileModal,
  parseFileNotification,
} from './libs/file-notification.lib'
import {
  ModalResponse,
  NgModalServiceInterface,
} from '../../models/modal.model'

@Injectable({
  providedIn: 'root',
})
export class FilesRepository {
  constructor(
    private ngModalService?: NgModalServiceInterface,
    private ngNotificationService?: NgNotificationServiceInterface,
  ) {}

  notify(options: { code?: FileNotificationCode; message?: string }): void {
    this.ngNotificationService?.show(
      options.message
        ? { title: 'Error', message: options.message, color: 'error' }
        : parseFileNotification(options.code),
    )
  }

  async alert(code: FileModalCode): Promise<ModalResponse> {
    const settings = parseFileModal(code)
    if (!this.ngModalService || !settings) {
      return 'closed'
    }
    return await this.ngModalService.showDialog(settings)
  }
}
